<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          @click="RoteAddpermissions()"
          v-if=" !isAdmin && permissions.delete"
          small
          color="primary"
        >mdi-magnify-plus-outline</v-icon>
      </template>
      <span>+ Permissões</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          @click="editData(item)"
          v-if="!isAdmin && permissions.update"
          small
          color="#1DE9B6"
        >mdi-square-edit-outline</v-icon>
      </template>
      <span>Editar</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          @click="deleteData(item)"
          v-if="!isAdmin && permissions.read && !isDefault"
          small
          color="#D32F2F"
        >mdi-delete-outline</v-icon>
      </template>
      <span>Excluir</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "RoleActions",
  props: {
    item: {
      type: Object,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    areaAccess: {
      type: String,
    },
  },
  computed: {
    isAdmin() {
      return this.item.name === "Administrador" ? true : false;
    },
    isDefault() {
      return this.item.is_default;
    },
  },
  methods: {
    editData(item) {
      this.$emit("edit-data", item.id);
    },
    deleteData(item) {
      this.$emit("delete-data", item.id);
    },
    RoteAddpermissions() {
      this.$router.push(`/${this.areaAccess}/${this.item.id}/permissions`);
    },
  },
};
</script>